import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

constructor() { }

featuredProducts = "FEATURED PRODUCTS";
women = "WOMEN";
men = "MEN";
accessories = "ACCESSORIES";
newArrivals = "NEW ARRIVALS";
customerReviews = "CUSTOMER REVIEWS";
dealOfTheDay = "DEAL OF THE DAY";
shopNow = "SHOP NOW";
nowOnly = "NOW_ONLY";
emptyField = "EMPTY_FIELD";

sliderOne1="SLIDER_ONE_1";
sliderOne2="SLIDER_ONE_2";
sliderTwo1="SLIDER_TWO_1";
sliderTwo2="SLIDER_TWO_2";
sliderThree1="SLIDER_THREE_1";
sliderThree2="SLIDER_THREE_2";

freeShipping1 = "FREE_SHIPPING_1";
freeShipping2 = "FREE_SHIPPING_2";
freeShipping3 = "FREE_SHIPPING_3";
friendlySupport1 = "FRIENDLY_SUPPORT_1";
friendlySupport2 = "FRIENDLY_SUPPORT_2";
friendlySupport3 = "FRIENDLY_SUPPORT_3";
secure1 = "SECURE1";
secure2 = "SECURE2";
secure3 = "SECURE3";

saleComponentOne1 = "SALE_ONE_1";
saleComponentOne2 = "SALE_ONE_2";
saleComponentOne3 = "SALE_ONE_3";

saleComponentTwo1 = "SALE_TWO_1";
saleComponentTwo2 = "SALE_TWO_2";
saleComponentTwo3 = "SALE_TWO_3";

saleComponentThree1 = "SALE_THREE_1";
saleComponentThree2 = "SALE_THREE_2";
saleComponentThree3 = "SALE_THREE_3";


}


